import { useAppBarHeight } from "./useAppBarHeight";

export const useStickyTopElementsHeight = (withStickyAppBar: boolean) => {
    const appBarHeight = useAppBarHeight();
    return withStickyAppBar ? appBarHeight : 0;
};
